const getDateYear = (date = new Date()) => date.getFullYear()

export default getDateYear